module.exports = __webpack_public_path__ + "img/wrinkle_l32wsk_c_scale,w_200.775636cf.jpg";